/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForAzureManagedIdentity extends models.ServiceAccountEphemeralCredentialsBaseForAzure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForAzureManagedIdentity");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForAzureManagedIdentity.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForAzureManagedIdentity>): ServiceAccountEphemeralCredentialsForAzureManagedIdentity {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForAzureManagedIdentity(), model);
        ServiceAccountEphemeralCredentialsForAzureManagedIdentity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForAzureManagedIdentity>): ServiceAccountEphemeralCredentialsForAzureManagedIdentity {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForAzureManagedIdentity.newInstance(<ServiceAccountEphemeralCredentialsForAzureManagedIdentity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForAzureManagedIdentity) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForAzureManagedIdentity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForAzureManagedIdentity): boolean {
        if (models.ServiceAccountEphemeralCredentialsBaseForAzure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForAzureManagedIdentity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Token
     */
    access_token: string;

}
